module.exports = ".containerSpinner {\n    position: relative;\n}\nspinner-component {\n    position: absolute;\n    top: -5px;\n    right: 12px;\n}\n\nselect[multiple] {\n    min-height: 300px;\n    line-height: 12px;\n}\nselect[multiple] option {\n    padding: 2px;\n}\n\nselect[multiple] option.select {\n    background-color: red;\n    color: #fff;\n}\n\n.icon {\n    position: relative;\n    top: 5px;\n}\n\n.hidden {\n    visibility: hidden;\n    margin: 0;\n    padding: 0;\n    height: 1px;\n    position: absolute;\n}\n\n.noMargin .geo-input--6c,\n.noMargin .geo-input--3c {\n    margin-bottom: 0;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/rastreamentos/alarmes/alarme-form/alarme-form.component.css
 ** module id = 872
 ** module chunks = 0
 **/